import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const Ctx = createContext(null);

export function PropertyProvider({ children }) {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("pms_active_property") || "");
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const r = await api.get("/properties");
      setProperties(r.data);
      if (r.data.length > 0) {
        const stored = localStorage.getItem("pms_active_property");
        if (!stored || !r.data.find((p) => p.id === stored)) {
          setActiveId(r.data[0].id);
          localStorage.setItem("pms_active_property", r.data[0].id);
        }
      }
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const setActive = (id) => {
    setActiveId(id);
    localStorage.setItem("pms_active_property", id);
    window.dispatchEvent(new CustomEvent("pms:property", { detail: { id } }));
  };

  const active = properties.find((p) => p.id === activeId);
  return (
    <Ctx.Provider value={{ properties, activeId, active, setActive, refresh, loading }}>
      {children}
    </Ctx.Provider>
  );
}

export const useProperty = () => useContext(Ctx);
